export default __webpack_public_path__ + "7d617dd4003e4751cd964252acf30606.svg";